import axios from 'axios'

export async function listCoins(){
    const res = await axios.get('/cg/v3/coins?include_platform=false')
    return res.data
}

export async function listCoinIds(){
    const res = await axios.get('/cg/v3/coins/list')
    return res.data
}

export async function getCoinInfo(coinId){
    const res = await axios.get(`/cg/v3/coins/${coinId}`)
    return res.data
}

export async function getTrendingCoins(){
    const res = await axios.get(`/cg/v3/search/trending`)
    return res.data.coins
}